/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import { service } from "@ember/service";
import { dasherize } from "@ember/string";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { ForcBaseArgs } from "core/components/forc/abstract/base-component";
import Patient from "core/models/patient";
import { sleep } from "core/utils/time";
import { toLeft, toRight } from "ember-animated/transitions/move-over";
import { EmberChangeset } from "ember-changeset";
import { IntlService } from "ember-intl";
let MultiStepsEditionForm = (_class = class MultiStepsEditionForm extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _defineProperty(this, "duration", 300);
    _initializerDefineProperty(this, "currentIndex", _descriptor2, this);
  }
  rules({
    oldItems,
    newItems
  }) {
    if (oldItems[0] < newItems[0]) {
      return toLeft;
    }
    return toRight;
  }
  async previousQuestion() {
    await sleep(this.duration / 2);
    this.currentIndex--;
  }
  get currentQuestionKey() {
    return this.args.currentSections[this.currentIndex];
  }
  async nextQuestion() {
    await sleep(this.duration / 2);
    this.currentIndex++;
  }
  get isOnSummary() {
    return this.currentIndex == this.args.currentSections.length;
  }
  get editionFormComponent() {
    return this.args.questions[dasherize(this.currentQuestionKey)];
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentIndex", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "previousQuestion", [action], Object.getOwnPropertyDescriptor(_class.prototype, "previousQuestion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextQuestion", [action], Object.getOwnPropertyDescriptor(_class.prototype, "nextQuestion"), _class.prototype), _class);
export { MultiStepsEditionForm as default };